import { defineMessages } from 'react-intl';

const messages = defineMessages({
  // Panels
  Identification: 'Identification',
  User: 'User',

  // Identification fields
  LastName: 'Last name',
  FirstName: 'First name',
  Initials: 'Initials',
  Phone: 'Phone',
  MobilePhone: { id: 'Mobile', defaultMessage: 'Mobile' },
  PersonalEmail: 'Personal email',
  Address: 'Address',
  DateOfBirth: 'Date of birth',
  Gender: 'Gender',
  EmergencyContactName: 'Emergency contact name',
  EmergencyContactPhone: 'Emergency contact phone number',
  StartOfEmployment: { id: 'Start of employment', defaultMessage: 'Start of employment' },
  EndOfEmployment: { id: 'EmploymentEndDate', defaultMessage: 'End of employment' },
  EndDate: 'End date',
  OwnCompany: 'OwnCompany',
  EmployeeType: 'EmployeeType',
  CallerId: 'Caller ID',
  InsurancePolicyNumber: {
    id: 'InsurancePolicyReference',
    defaultMessage: 'Insurance policy number',
  },
  EmployeeNumber: 'Employee number',

  // User fields
  Username: 'Username',
  EmailConfirmed: 'Email confirmed',
  EmailForPlaceholders: {
    id: 'EmailAddressPlaceholdersAndEmailCommunication',
    defaultMessage: 'E-mailaddress for placeholders and e-mail communication',
  },
  Role: 'Role',
  SignInMethod: 'Sign in method',
  Sso: 'SSO',
  UsernamePassword: 'Username/password',
  TwoFactorAuthentication: 'Two-factor authentication (2FA)',
  Enabled: 'Enabled',
  NotEnabled: 'Not enabled',
  PriceProfile: 'Price profile',
  OpenPriceProfiles: 'Open price profiles',
  Unassigned: 'Unassigned',
  Default: 'Default',
  Teams: { id: 'Team(s)', defaultMessage: 'Team(s)' },
  InternalCostPerHour: 'Internal cost (per hour)',
  InternalCostPlaceholder: 'Internal cost',
  IntraCompanyBillingUnitPrice: 'IntraCompanyBillingUnitPrice',
  Title: 'Title',
  RemainingOvertimeHours: 'Remaining overtime hours',
  TemporaryLicense: 'Temporary license',
  Tags: 'Tags',
  LanguageForEmails: 'Language for emails',
  EmailRemark: 'Email remark',
  TravelStartLocation: 'Travel start location',
  EmployeeHomeAddress: 'Employee home address',
  CompanyAddress: 'Company address',
  DefaultTravelRoute: 'Default travel route',
  OneWay: 'One way',
  ToAndFro: 'To and fro',
  WorkdayStartHour: 'Workday start hour',
  WorkdayEndHour: 'Workday end hour',
  Remark: 'Remark',
  AddUserProfile: 'Add user profile',

  // Action buttons
  DeleteEmployee: 'Delete employee',
  RestoreEmployee: 'Restore employee',
  CreateTimeTable: 'Create time table',
  EditTimeTable: 'Edit time table',
  DeleteTimeTable: 'Delete time table',
  OvertimeCorrections: 'Overtime corrections',
  AIRendementRapport: 'AI Rendement rapport',
  ResetTwoFactorAuthentication: 'Reset two-factor authentication',

  // Confirmations / toasts (reuse existing translation keys)
  ConfirmChange: { id: 'msgConfirmChange', defaultMessage: 'Changes saved' },
  ConfirmResetTwoFaTitle: {
    id: 'msgConfirmResetTwoFaTitle',
    defaultMessage: 'Reset two-factor authentication?',
  },
  ConfirmResetTwoFa: {
    id: 'msgConfirmResetTwoFa',
    defaultMessage: 'Are you sure you want to reset two-factor authentication for this user?',
  },
  ConfirmDeleteTitle: { id: 'msgConfirmDeleteTitle', defaultMessage: 'Delete?' },
  ConfirmDeleteTimeTable: {
    id: 'msgConfirmDeleteTimeTable',
    defaultMessage: 'Are you sure you want to delete this time table?',
  },
  EmployeeRestoreSuccessful: {
    id: 'msgEmployeeRestoreSuccesful',
    defaultMessage: 'Employee restored successfully',
  },

  // Common
  Save: 'Save',
  Cancel: 'Cancel',
  Yes: 'Yes',
  No: 'No',
  Delete: 'Delete',
  FieldRequired: { id: 'msgRequiredField', defaultMessage: 'This field is required' },
  InvalidEmailAddress: 'Invalid email address',
  GenericError: { id: 'GenericError', defaultMessage: 'Something went wrong' },

  // Create user profile dialog
  CreateUserProfile: 'Create user profile',
  CreateUser: 'Create user',
  Choose: 'Choose',

  // Recalculate registrations (internal price) dialog
  RecalculateRegistrations: 'Recalculate registrations',
  RecalculateRegistrationsWithNewPrice: 'Recalculate registrations with new price.',
  RegistrationsFrom: 'Registrations from',
  RegistrationsUntil: 'Registrations until',
  Confirm: 'Confirm',
  StartEndDateRequired: {
    id: 'msgStartEndDateRequiredUpdateInternalPrice',
    defaultMessage: 'Start and end date are required to recalculate registrations',
  },

  // Insight dialog
  EmployedSince: 'Start date',
  GeneratingReport: 'Generating report...',
  NewReport: 'New report',
  Generate: 'Generate',
  Close: 'Close',

  // Time table dialog
  EmployeeTimeTable: 'Employee time table',
  Morning: 'Morning',
  Afternoon: 'Afternoon',
  TotalTime: 'Total time',
  WorkingFromHome: 'Working from home',
  WeekTotal: 'Week total',
  ProductivityPercentage: 'Productivity percentage',
  TimeTableStartDate: 'Start date',
  PreviousStartDate: 'Previous start date',
  TimeTableStartDateInfo:
    'The time table is applied from this date. Registrations before this date keep their original time table.',

  // Overtime dialog
  Date: 'Date',
  Correction: 'Correction',
  SubtractTime: 'Subtract time',
  AddTime: 'Add time',
  RemainingOvertimeHoursAfterCorrection: 'Remaining overtime after correction',
  CreatedOn: 'Created on',
  By: 'By',
  PreviousRemainingOvertime: 'Previous remaining overtime',
});

export default messages;
